import { createSlice } from "@reduxjs/toolkit";

export const deleteProspectiveSellRecordSlice = createSlice({
  name: "deleteProspectiveSellRecordSlice",
  initialState: {
    isDeletingProspectiveSellRecord: false,
    deleteProspectiveSellRecordMessage: null,
    deleteProspectiveSellRecordError: null,
    recordToken: null,
  },
  reducers: {
    deleteProspectiveSellRecord: (state, action) => {
      state.isDeletingProspectiveSellRecord = true;
      state.deleteProspectiveSellRecordMessage = null;
      state.deleteProspectiveSellRecordError = null;
      state.recordToken = action.payload;
    },
    deleteProspectiveSellRecordSuccessful: (state, action) => {
      state.isDeletingProspectiveSellRecord = false;
      state.deleteProspectiveSellRecordMessage = action.payload;
      state.deleteProspectiveSellRecordError = null;
      state.recordToken = null;
    },
    deleteProspectiveSellRecordFailure: (state, action) => {
      state.isDeletingProspectiveSellRecord = false;
      state.deleteProspectiveSellRecordMessage = null;
      state.deleteProspectiveSellRecordError = action.payload.message;
      state.recordToken = null;
    },
    clearAllDeleteProspectiveSellRecordMessages: (state) => {
      state.deleteProspectiveSellRecordMessage = null;
      state.deleteProspectiveSellRecordError = null;
    },
  },
});

export const {
  deleteProspectiveSellRecord,
  deleteProspectiveSellRecordSuccessful,
  deleteProspectiveSellRecordFailure,
  clearAllDeleteProspectiveSellRecordMessages,
} = deleteProspectiveSellRecordSlice.actions;

export default deleteProspectiveSellRecordSlice.reducer;
